(function (scope) {
  'use strict';
  const frameSizes = { '6x8': 17, '9x12': 22, '16x20': 75, '18x24': 110, '24x36': 200 };
  const sizeKey = (w, h) => [w, h].sort((a, b) => a - b).join('x');
  const dimensions = (w, h) => {
    const width = Number(w), height = Number(h);
    return Number.isFinite(width) && Number.isFinite(height) && width >= 1 && height >= 1 && width <= 600 && height <= 600 ? { width, height } : null;
  };
  const project = (lat, lng) => {
    const sin = Math.sin(lat * Math.PI / 180);
    return { x: (lng + 180) / 360 * 256, y: (0.5 - Math.log((1 + sin) / (1 - sin)) / (4 * Math.PI)) * 256 };
  };
  const unproject = (x, y) => ({ lng: x / 256 * 360 - 180, lat: Math.atan(Math.sinh(Math.PI * (1 - 2 * y / 256))) * 180 / Math.PI });
  const boundsAt = (lat, lng, worldWidth, ratio) => {
    if (![lat, lng, worldWidth, ratio].every(Number.isFinite) || Math.abs(lat) >= 85 || Math.abs(lng) > 180 || worldWidth <= 0 || worldWidth >= 128 || ratio <= 0) return null;
    const c = project(lat, lng), nw = unproject(c.x - worldWidth / 2, c.y - worldWidth / ratio / 2), se = unproject(c.x + worldWidth / 2, c.y + worldWidth / ratio / 2);
    if (nw.lat >= 85 || se.lat <= -85 || nw.lng < -180 || se.lng > 180) return null;
    return { north: nw.lat, south: se.lat, east: se.lng, west: nw.lng };
  };
  const estimate = (d, finish, display, config, selection) => {
    if (!d) return null;
    const key = sizeKey(d.width, d.height), area = d.width * d.height;
    if (selection === 'custom' || !['6x8', '9x12', '12x16', '16x20'].includes(key)) return null;
    const finishes = finish === 'unsure' ? ['single', 'multi'] : [finish];
    if (display !== 'unframed' && !Object.hasOwn(frameSizes, key)) return null;
    const values = finishes.map((style) => {
      const price = config.prices[style];
      if (!price) return null;
      if (key === '6x8') {
        const value = Number(price[display]);
        return value > 0 ? [value, value] : null;
      }
      if (config.currency !== 'USD' || area > 3600 || Math.max(d.width, d.height) > 96) return null;
      const regular = Number(price.regular);
      if (!(regular > 0)) return null;
      const frame = display === 'unframed' ? 0 : frameSizes[key] * 100;
      const [low, high] = key === '16x20' ? [style === 'multi' ? 42500 : 35000, style === 'multi' ? 42500 : 35000] : [regular * area / 48, regular * area / 48 * 1.25];
      return [Math.floor((low + frame) / 500 + 1e-9) * 500, Math.ceil((high + frame) / 500 - 1e-9) * 500];
    });
    if (values.some((value) => !value)) return null;
    return { low: Math.min(...values.map((v) => v[0])), high: Math.max(...values.map((v) => v[1])), currency: config.currency, basis: key === '6x8' ? 'Current Shopify 8x6 variant prices' : key === '16x20' ? 'Studio 16x20 planning prices; standard frame allowance' : 'Area-scaled regular Shopify 8x6 price, 0–25% planning range, standard frame allowance' };
  };
  const core = { dimensions, boundsAt, project, unproject, estimate, sizeKey, frameSizes };
  if (typeof module !== 'undefined' && module.exports) module.exports = core;
  if (!scope.document) return;

  const initialize = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const $ = (selector) => root.querySelector(selector);
    const config = JSON.parse($('[data-config]').textContent);
    const copy = config.copy;
    const form = $('form'), controls = $('[data-controls]'), size = $('[data-size]'), width = $('[data-width]'), height = $('[data-height]');
    const finish = $('[data-finish]'), display = $('[data-display]'), mapNode = $('[data-map]'), frame = $('[data-frame]');
    const confirm = $('[data-confirm]'), search = $('[data-search]'), searchButton = $('[data-find]'), rotate = $('[data-rotate]');
    const state = { map: null, rectangle: null, bounds: null, confirmed: null, rotated: false, sending: false, sent: false, uncertain: false, selectedPlace: '', searchSequence: 0, searching: false, searchMessage: '', pendingResults: false, frameWidth: 0, frameHeight: 0, manual: false, resizeTimer: null };
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: config.currency, maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    const txt = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('{' + name + '}', value), copy[key] || key);
    const setField = (name, value) => { const field = form.elements.namedItem(name); if (field) field.value = value; };
    const currentDimensions = () => {
      const pair = size.value === 'custom' ? [width.value, height.value] : size.value.split('x');
      const d = dimensions(...pair);
      return d && state.rotated ? { width: d.height, height: d.width } : d;
    };
    const sizeText = (d) => d ? `${d.width}x${d.height} in` : '';
    const mapCanAdjust = () => !!state.map && !!currentDimensions() && !state.confirmed && !state.searching && !state.pendingResults;
    const updateMapControls = () => {
      const blocked = !mapCanAdjust();
      const zoom = state.map?.getZoom();
      root.querySelectorAll('[data-zoom], [data-fine-zoom]').forEach((button) => {
        const direction = Number(button.dataset.zoom || button.dataset.fineZoom);
        button.disabled = blocked || (direction > 0 ? zoom >= 20 : zoom <= 2);
      });
      if ($('[data-fine-controls]')) $('[data-fine-controls]').disabled = blocked;
      if ($('[data-fine-help]')) $('[data-fine-help]').textContent = state.confirmed ? copy.fine_locked : copy.fine_help;
    };
    const status = (text) => { $('[data-map-status]').textContent = text; };
    const error = (text, target) => {
      const node = $('[data-error]'); node.textContent = text; node.hidden = !text;
      if (text) (target || node).focus();
    };
    const updateSummary = () => {
      const d = currentDimensions();
      $('[data-summary]').textContent = d ? `${sizeText(d)} · ${finish.selectedOptions[0].textContent} · ${display.selectedOptions[0].textContent} · ${state.confirmed ? copy.saved_area : copy.area_needed}` : copy.dimensions_needed;
    };
    const clearFields = () => {
      ['properties[_Bounding Box NE]', 'properties[_Bounding Box SW]', 'properties[_Map Preview]', 'Area GeoJSON', 'Area center', 'Area confirmed at', 'Area projection'].forEach((name) => setField(name, ''));
    };
    const unlock = () => {
      state.confirmed = null; state.manual = false; clearFields();
      $('[data-bounds-text]').hidden = true;
      if (state.rectangle) { state.rectangle.setMap(null); state.rectangle = null; }
      if (state.map) state.map.setOptions({ gestureHandling: 'greedy', keyboardShortcuts: true, draggable: true, disableDoubleClickZoom: false });
      frame.hidden = !state.map; search.disabled = false; searchButton.disabled = !state.map;
      updateMapControls();
      confirm.textContent = copy.confirm; status(copy.adjust_area); updateSummary();
    };
    const layoutFrame = () => {
      const d = currentDimensions();
      if (!d || state.confirmed) { if (!d) frame.hidden = true; return; }
      const ratio = d.width / d.height;
      const availableWidth = Math.max(1, mapNode.clientWidth - 52), availableHeight = Math.max(1, mapNode.clientHeight - 108);
      state.frameWidth = Math.min(availableWidth, availableHeight * ratio); state.frameHeight = state.frameWidth / ratio;
      frame.style.width = state.frameWidth + 'px'; frame.style.height = state.frameHeight + 'px';
      $('[data-frame-label]').textContent = sizeText(d);
      frame.hidden = !state.map;
    };
    const updateCandidate = () => {
      updateMapControls();
      if (!state.map || state.confirmed) return;
      const d = currentDimensions(), center = state.map.getCenter();
      state.bounds = d && center ? boundsAt(center.lat(), center.lng(), state.frameWidth / 2 ** state.map.getZoom(), d.width / d.height) : null;
      confirm.disabled = !state.bounds || state.searching || state.pendingResults;
      if (state.searching) status(copy.searching);
      else if (state.searchMessage) status(state.searchMessage);
      else if (!state.bounds) status(copy.zoom_in);
      else status(copy.adjust_area);
    };
    const updateChoices = (invalidate = true) => {
      if (invalidate) unlock();
      const d = currentDimensions();
      $('[data-custom]').hidden = size.value !== 'custom';
      width.required = height.required = size.value === 'custom';
      width.disabled = height.disabled = size.value !== 'custom';
      const frameAvailable = d && Object.hasOwn(frameSizes, sizeKey(d.width, d.height));
      for (const option of display.options) if (option.value !== 'unframed') option.disabled = !frameAvailable;
      if (!frameAvailable) display.value = 'unframed';
      $('[data-frame-help]').hidden = !!frameAvailable;
      const result = estimate(d, finish.value, display.value, config, size.value);
      $('[data-estimate]').textContent = result ? (result.low === result.high ? money(result.low) : `${money(result.low)} – ${money(result.high)}`) : (d ? copy.quote_needed : copy.dimensions_needed);
      $('[data-estimate-note]').textContent = result ? (sizeKey(d.width, d.height) === '6x8' ? copy.standard_note : copy.estimate_note) : copy.quote_note;
      $('[data-construction]').hidden = !d || Math.max(d.width, d.height) <= 9;
      setField('Model dimensions', sizeText(d));
      setField('Model width inches', d?.width || ''); setField('Model height inches', d?.height || '');
      setField('Display format', display.selectedOptions[0].textContent); setField('Color preference', finish.selectedOptions[0].textContent);
      setField('Rough estimate', $('[data-estimate]').textContent); setField('Estimate currency', config.currency);
      setField('Estimate basis', result?.basis || 'Individual quote required');
      setField('Map footprint ratio', d ? `${d.width}:${d.height}` : '');
      rotate.disabled = !d || d.width === d.height;
      layoutFrame(); updateCandidate(); updateSummary();
    };
    const fitConfirmed = () => {
      if (!state.map || !state.confirmed) return;
      state.map.fitBounds(state.confirmed, 42);
    };
    const saveArea = (bounds, manual = false) => {
      const d = currentDimensions(); if (!d || !bounds) return;
      state.searchSequence++; state.searching = false; state.pendingResults = false; state.searchMessage = '';
      $('[data-search-results]').replaceChildren();
      if (!manual) root.querySelectorAll('[data-lat], [data-lng], [data-km]').forEach((field) => { field.value = ''; });
      state.confirmed = { ...bounds }; state.manual = manual; state.bounds = { ...bounds };
      const { north, south, east, west } = bounds;
      const center = unproject((project(north, west).x + project(south, east).x) / 2, (project(north, west).y + project(south, east).y) / 2);
      const round = (n) => Number(n.toFixed(7));
      setField('properties[_Bounding Box NE]', `NE: ${north.toFixed(7)}, ${east.toFixed(7)}`);
      setField('properties[_Bounding Box SW]', `SW: ${south.toFixed(7)}, ${west.toFixed(7)}`);
      setField('properties[Selected Area]', state.selectedPlace || `${center.lat.toFixed(6)}, ${center.lng.toFixed(6)}`);
      setField('Area center', `${center.lat.toFixed(7)}, ${center.lng.toFixed(7)}`);
      setField('Area confirmed at', new Date().toISOString());
      setField('Area projection', 'EPSG:3857 rectangular footprint; coordinates in EPSG:4326');
      setField('Area GeoJSON', JSON.stringify({ type: 'Feature', properties: { width_in: d.width, height_in: d.height, selection_projection: 'EPSG:3857' }, geometry: { type: 'Polygon', coordinates: [[[round(west), round(south)], [round(east), round(south)], [round(east), round(north)], [round(west), round(north)], [round(west), round(south)]]] } }));
      if (config.mapsKey) {
        const params = new URLSearchParams({ key: config.mapsKey, size: '640x480', maptype: 'terrain', visible: `${north},${east}|${south},${west}`, path: `color:0xd8b950ff|weight:3|${north},${west}|${north},${east}|${south},${east}|${south},${west}|${north},${west}` });
        setField('properties[_Map Preview]', 'https://maps.googleapis.com/maps/api/staticmap?' + params);
      }
      frame.hidden = true;
      if (state.map) {
        if (state.rectangle) state.rectangle.setMap(null);
        state.rectangle = new google.maps.Rectangle({ map: state.map, bounds, clickable: false, editable: false, draggable: false, strokeColor: '#e4c962', strokeWeight: 3, fillColor: '#e4c962', fillOpacity: 0.08 });
        state.map.setOptions({ gestureHandling: 'none', draggable: false, keyboardShortcuts: false, disableDoubleClickZoom: true });
        if (manual) fitConfirmed();
      }
      confirm.disabled = false; confirm.textContent = copy.adjust;
      search.disabled = true; searchButton.disabled = true;
      updateMapControls();
      status(txt('confirmed', { size: sizeText(d) })); updateSummary();
      $('[data-bounds-text]').textContent = `NE ${north.toFixed(6)}, ${east.toFixed(6)} · SW ${south.toFixed(6)}, ${west.toFixed(6)}`;
      $('[data-bounds-text]').hidden = false;
      error('');
    };
    [size, width, height].forEach((field) => field.addEventListener(field === size ? 'change' : 'input', () => { state.rotated = false; updateChoices(); }));
    [finish, display].forEach((field) => field.addEventListener('change', () => updateChoices(false)));
    rotate.addEventListener('click', () => {
      if (size.value === 'custom') { const previousWidth = width.value; width.value = height.value; height.value = previousWidth; state.rotated = false; }
      else state.rotated = !state.rotated;
      updateChoices();
    });
    confirm.addEventListener('click', () => { if (state.confirmed) { unlock(); layoutFrame(); updateCandidate(); } else { updateCandidate(); saveArea(state.bounds); } });
    const changeZoom = (amount) => {
      if (!mapCanAdjust()) return;
      state.map.setZoom(Math.min(20, Math.max(2, state.map.getZoom() + amount)));
      updateCandidate();
    };
    root.querySelectorAll('[data-zoom]').forEach((button) => button.addEventListener('click', () => changeZoom(Number(button.dataset.zoom))));
    root.querySelectorAll('[data-fine-zoom]').forEach((button) => button.addEventListener('click', () => {
      const step = $('[data-fine-step]').checked ? 1.0025 : 1.01;
      changeZoom(Number(button.dataset.fineZoom) * Math.log2(step));
    }));
    root.querySelectorAll('[data-nudge]').forEach((button) => button.addEventListener('click', () => {
      if (!mapCanAdjust()) return;
      const center = state.map.getCenter(), point = project(center.lat(), center.lng());
      const pixels = $('[data-fine-step]').checked ? 1 : 5;
      const distance = pixels / 2 ** state.map.getZoom();
      const [x, y] = button.dataset.nudge.split(',').map(Number);
      const next = unproject(point.x + x * distance, point.y + y * distance);
      state.map.setCenter(next);
      updateCandidate();
    }));
    $('[data-clear]').addEventListener('click', () => { unlock(); state.searchSequence++; state.searching = false; state.pendingResults = false; state.searchMessage = ''; state.selectedPlace = ''; search.value = ''; $('[data-search-results]').replaceChildren(); $('[data-bounds-text]').hidden = true; if (state.map) { state.map.setCenter({ lat: 39.8283, lng: -98.5795 }); state.map.setZoom(4); } updateCandidate(); });
    $('[data-manual-save]').addEventListener('click', () => {
      const latField = $('[data-lat]'), lngField = $('[data-lng]'), kmField = $('[data-km]');
      const d = currentDimensions();
      if (![latField, lngField, kmField].every((field) => field.value.trim() && field.checkValidity()) || !d) { error(copy.manual_error, latField); return; }
      const lat = Number(latField.value), lng = Number(lngField.value), km = Number(kmField.value);
      const worldWidth = km * 1000 / (40075016.6856 * Math.cos(lat * Math.PI / 180)) * 256;
      const bounds = boundsAt(lat, lng, worldWidth, d.width / d.height);
      if (!bounds) { error(copy.bounds_error, kmField); return; }
      state.selectedPlace = `${lat}, ${lng}`; saveArea(bounds, true);
    });
    const performSearch = async () => {
      if (!state.map || state.confirmed || !search.value.trim()) return;
      const sequence = ++state.searchSequence, query = search.value.trim();
      state.searching = true; state.pendingResults = false; state.searchMessage = ''; searchButton.disabled = true; confirm.disabled = true; status(copy.searching);
      updateMapControls();
      const resultsNode = $('[data-search-results]'); resultsNode.replaceChildren();
      try {
        let searchTimeout;
        const request = new google.maps.Geocoder().geocode({ address: query });
        const { results } = await Promise.race([request, new Promise((resolve, reject) => { searchTimeout = setTimeout(() => reject(new Error('timeout')), 15000); })]).finally(() => clearTimeout(searchTimeout));
        if (sequence !== state.searchSequence || search.value.trim() !== query || state.confirmed) return;
        if (!results.length) throw new Error('empty');
        const select = (place) => {
          state.pendingResults = false; state.searchMessage = ''; state.selectedPlace = place.formatted_address; search.value = place.formatted_address; resultsNode.replaceChildren();
          if (place.geometry.viewport) state.map.fitBounds(place.geometry.viewport, 54);
          else { state.map.setCenter(place.geometry.location); state.map.setZoom(12); }
          error(''); updateCandidate();
        };
        if (results.length === 1) select(results[0]);
        else {
          state.pendingResults = true; state.searchMessage = copy.choose_result; status(copy.choose_result);
          results.slice(0, 5).forEach((place) => { const button = document.createElement('button'); button.type = 'button'; button.textContent = place.formatted_address; button.addEventListener('click', () => select(place)); resultsNode.append(button); });
        }
      } catch { if (sequence === state.searchSequence) { state.searchMessage = copy.search_failed; status(copy.search_failed); } }
      finally { if (sequence === state.searchSequence) { state.searching = false; searchButton.disabled = !state.map || !!state.confirmed; updateCandidate(); } }
    };
    searchButton.addEventListener('click', performSearch);
    search.addEventListener('input', () => { state.searchSequence++; state.searching = false; state.pendingResults = false; state.searchMessage = ''; searchButton.disabled = !state.map; $('[data-search-results]').replaceChildren(); updateCandidate(); });
    search.addEventListener('keydown', (event) => { if (event.key === 'Enter') { event.preventDefault(); performSearch(); } });
    const attachment = $('[data-attachment]');
    const validateAttachment = () => {
      const file = attachment.files[0];
      const allowed = /\.(jpe?g|png|webp|heic|heif|pdf|gpx|kml|kmz|geojson|zip)$/i;
      const message = file && file.size > 10 * 1024 * 1024 ? copy.file_too_large : file && !allowed.test(file.name) ? copy.file_type_error : '';
      attachment.setCustomValidity(message);
      $('[data-file-error]').textContent = message;
      $('[data-file-error]').hidden = !message;
      $('[data-remove-file]').hidden = !file;
      return !message;
    };
    attachment.addEventListener('change', validateAttachment);
    $('[data-remove-file]').addEventListener('click', () => { attachment.value = ''; validateAttachment(); attachment.focus(); });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (state.sending || state.sent || state.uncertain) return;
      validateAttachment();
      if (!form.reportValidity()) return;
      if (!currentDimensions()) { error(copy.dimensions_needed, width); return; }
      if (!state.confirmed) { error(copy.area_needed, confirm); return; }
      if (form.elements.namedItem('_gotcha').value) return;
      setField('properties[Email]', $('[data-email]').value.trim());
      if (!form.elements.namedItem('Inquiry reference').value) setField('Inquiry reference', 'TS-' + (crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36)).slice(0, 12));
      const sourceParams = new URLSearchParams(location.search);
      if (sourceParams.get('source') === 'custom_map_order') {
        setField('Lead source', 'Custom map order form');
        setField('Lead priority', 'High interest: customer came from the order form');
        setField('Inquiry reason', 'larger_or_custom_size');
        setField('Source product', (sourceParams.get('source_product') || '').replace(/[^a-z0-9-]/g, '').slice(0, 180));
        setField('_subject', 'Custom size inquiry from order form');
      }
      const body = new FormData(form);
      if (!attachment.files.length) body.delete('attachment');
      const areaGeoJson = body.get('Area GeoJSON');
      if (typeof areaGeoJson === 'string' && areaGeoJson.trim()) {
        const reference = String(body.get('Inquiry reference') || 'Terrastratas').replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 80) || 'Terrastratas';
        body.append('area_boundary', new Blob([areaGeoJson + '\n'], { type: 'application/geo+json' }), reference + '_area.geojson');
      }
      state.sending = true; controls.disabled = true; $('[data-submit]').textContent = copy.sending; error('');
      const controller = new AbortController(); const timer = setTimeout(() => controller.abort(), 25000);
      try {
        const response = await fetch(form.action, { method: 'POST', headers: { Accept: 'application/json' }, body, signal: controller.signal });
        const result = await response.json().catch(() => null);
        if (response.ok && result?.ok === true) {
          state.sent = true; $('[data-result]').hidden = false; $('[data-result]').textContent = txt('success', { reference: form.elements.namedItem('Inquiry reference').value }); $('[data-result]').focus(); $('[data-submit]').textContent = copy.sent;
        } else if (response.status >= 400 && response.status < 500) {
          error(response.status === 429 ? copy.rate_limited : attachment.files.length ? copy.file_send_failed : copy.send_failed);
        } else {
          state.uncertain = true; error(copy.delivery_unknown); $('[data-retry]').hidden = false;
        }
      } catch { state.uncertain = true; error(copy.delivery_unknown); $('[data-retry]').hidden = false; }
      finally { clearTimeout(timer); state.sending = false; controls.disabled = state.sent || state.uncertain; if (!state.sent) $('[data-submit]').textContent = copy.send; }
    });
    $('[data-retry]').addEventListener('click', () => { state.uncertain = false; controls.disabled = false; $('[data-retry]').hidden = true; error(''); });
    const initializeMap = () => {
      if (state.map || !scope.google?.maps?.Map) return;
      state.map = new google.maps.Map(mapNode, { center: { lat: 39.8283, lng: -98.5795 }, zoom: 4, minZoom: 2, maxZoom: 20, isFractionalZoomEnabled: true, mapTypeId: 'terrain', mapTypeControl: true, mapTypeControlOptions: { mapTypeIds: ['terrain', 'satellite'] }, disableDefaultUI: true, gestureHandling: 'greedy', keyboardShortcuts: true, tilt: 0, heading: 0, clickableIcons: false, restriction: { latLngBounds: { north: 84.9, south: -84.9, west: -180, east: 180 }, strictBounds: true } });
      $('[data-map-note]').hidden = true; searchButton.disabled = !!state.confirmed;
      updateMapControls();
      state.map.addListener('idle', updateCandidate);
      state.map.addListener('bounds_changed', updateCandidate);
      layoutFrame(); updateCandidate();
      if (state.confirmed) saveArea(state.confirmed, true);
    };
    const mapFailure = () => { if (state.map) return; $('[data-map-note]').textContent = copy.map_failed; $('[data-manual]').open = true; };
    controls.disabled = false; updateChoices(false);
    new ResizeObserver(() => {
      clearTimeout(state.resizeTimer); state.resizeTimer = setTimeout(() => {
        if (state.confirmed) fitConfirmed(); else { layoutFrame(); updateCandidate(); }
      }, 100);
    }).observe(mapNode);
    if (scope.google?.maps?.Map) initializeMap();
    else if (config.mapsKey) {
      const callback = 'tsSimpleInquiryMapsReady'; scope[callback] = initializeMap;
      const existing = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
      if (existing) {
        let tries = 0; const timer = setInterval(() => { if (scope.google?.maps?.Map) { clearInterval(timer); initializeMap(); } else if (++tries >= 60) { clearInterval(timer); mapFailure(); } }, 250);
      } else {
        const script = document.createElement('script'); script.async = true; script.src = 'https://maps.googleapis.com/maps/api/js?' + new URLSearchParams({ key: config.mapsKey, loading: 'async', callback, v: 'quarterly' }); script.onerror = mapFailure; document.head.append(script); setTimeout(mapFailure, 15000);
      }
    } else mapFailure();
  };
  const start = () => document.querySelectorAll('[data-simple-inquiry]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
})(typeof window === 'undefined' ? globalThis : window);
